
import axios from "axios";


import enviroment from "../../../enviroment";

const createAxiosInstances = () => {
  const config = {
    baseURL: enviroment.BASE_URL_LOGGER,
  };
  return axios.create(config);
};

const axiosLogger = createAxiosInstances();


const requesSuccessHandler = (value) => {
  const toJson = localStorage.getItem("@token");
  const data = toJson == null ? null : JSON.parse(toJson);

  if (data?.token) {
    value.headers = { Authorization: `Bearer ${data.token}` };
  }
  return value;
};

const requestErrorHandler = (error) => error;

axiosLogger.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        try {
          const token = await new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          });
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return await axios(originalRequest);
        } catch (err) {
          return Promise.reject(err);
        }
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise((resolve, reject) => {
        const tokenJson = localStorage.getItem("@token");

        const tokenParse = tokenJson == null ? null : JSON.parse(tokenJson);
        axiosLogger
          .get(`refreshtoken/${tokenParse.token}`)
          .then(({ data }) => {
            const newToken = {
              token: data?.token,
            };

            localStorage.setItem("@token", JSON.stringify(newToken));

            axios.defaults.headers.common.Authorization = `Bearer ${newToken?.token}`;
            originalRequest.headers.Authorization = `Bearer ${newToken?.token}`;
            processQueue(null, newToken?.token);
            resolve(axios(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }
    return Promise.reject(error);
  })


axiosLogger.interceptors.request.use(async (conf) => conf);

axiosLogger.interceptors.request.use(requesSuccessHandler, requestErrorHandler);
let isRefreshing = false;

let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

export default axiosLogger;
